// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */:host{flex:1}.few-row-container{align-items:baseline}.auth-height{height:36px;align-items:center}.field.align-items-top{align-items:flex-start}`, "",{"version":3,"sources":["webpack://./packages/builder-setup/system-vars/components/system-vars-jobs-tab/sys-vars-jobs-common-settings-subtab/sys-vars-jobs-common-settings-subtab.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAQA,MACE,MAAA,CAGF,mBACE,oBAAA,CAGF,aACE,WAAA,CACA,kBAAA,CAGF,uBACE,sBAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n:host {\n  flex: 1;\n}\n\n.few-row-container {\n  align-items: baseline;\n}\n\n.auth-height {\n  height: 36px;\n  align-items: center;\n}\n\n.field.align-items-top {\n  align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
